import './index.scss';
import { Application, Controller } from 'utils/stimulus';
import { trackViewFreemiumTrainerEvent } from '../utils';

export default class FreemiumTrainerFilterBanner extends Controller {
  get isInviteType() {
    return this.element.dataset.invite === 'true';
  }

  connect() {
    trackViewFreemiumTrainerEvent('filter banner', {
      invite: this.isInviteType
    });
    this.on('close', this.close.bind(this));
  }

  close() {
    this.element.remove();
  }

  handleButtonClick(event) {
    event.preventDefault();

    this.trigger('freemium-trainer-modal->openFreemiumTrainerModal');
  }
}

global.FreemiumTrainerApplication =
  global.FreemiumTrainerApplication || Application.start();
global.FreemiumTrainerApplication.register(
  'freemium-trainer-filter-banner',
  FreemiumTrainerFilterBanner
);
